<template>
  <div class="appointment-audit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><a href="#">业务管理</a></el-breadcrumb-item>
        <el-breadcrumb-item>预约审批</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    
    <el-card shadow="never" class="main-card">
      <!-- 搜索区域 -->
      <div class="search-form">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="预约单号">
            <el-input v-model="searchForm.appointmentNo" placeholder="输入单号搜索..." clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="经纪人信息">
            <el-input v-model="searchForm.brokerInfo" placeholder="姓名或手机号" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="预约类型">
            <el-select v-model="searchForm.type" placeholder="全部" clearable style="width: 130px;">
              <el-option label="出库预约" value="out"></el-option>
              <el-option label="入库预约" value="in"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预约日期">
            <el-date-picker
              v-model="searchForm.date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              style="width: 150px;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable style="width: 130px;">
              <el-option label="待审核" value="pending"></el-option>
              <el-option label="已通过" value="approved"></el-option>
              <el-option label="已拒绝" value="rejected"></el-option>
              <el-option label="已取消" value="cancelled"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
            <el-button size="small" @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 申请记录列表 -->
      <div class="table-container">
        <h3 class="table-title">申请记录列表</h3>
        <el-table 
          :data="tableData" 
          class="appointment-table"
          :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 500, height: '40px' }"
          :row-style="{ height: '60px' }"
        >
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="appointmentNo" label="预约单号" width="150" align="center">
            <template slot-scope="scope">
              <span class="appointment-no-link" @click="handleView(scope.row, false)">{{ scope.row.appointmentNo || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="预约类型" width="110" align="center">
            <template slot-scope="scope">
              <el-tag :type="isInbound(scope.row) ? 'success' : ''" size="small" effect="plain">
                {{ isInbound(scope.row) ? '入库预约' : '出库预约' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="经纪人" min-width="120" align="center">
            <template slot-scope="scope">
              <div>
                <div>{{ scope.row.brokerName || '-' }}</div>
                <div style="font-size: 12px; color: #909399; margin-top: 2px;">
                  {{ getMaskedPhone(scope.row.brokerPhone) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="预约车辆" min-width="120" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.drivers && scope.row.drivers.length > 0">
                <div v-for="(driver, index) in scope.row.drivers" :key="index" style="margin-bottom: 2px;">
                  <span>{{ driver.plateNumber || '-' }}</span>
                </div>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="申请数量" width="120" align="right">
            <template slot-scope="scope">
              <span>{{ scope.row.quantity || 0 }} 吨</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="预约时间" width="160" align="center">
            <template slot-scope="scope">
              {{ formatTime(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="110" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)" size="small" effect="plain" style="border-radius: 10px;">
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status === 'pending'" size="small" type="primary" @click="handleView(scope.row, true)">
                去审核
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          background
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'AppointmentAudit',
  data() {
    return {
      searchForm: {
        appointmentNo: '',
        brokerInfo: '',
        status: '',
        date: '',
        type: ''
      },
      tableData: [],
      pagination: {
        page: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        console.log('开始加载预约列表数据')
        const params = {
          ...this.searchForm,
          page: this.pagination.page,
          pageSize: this.pagination.size
        }
        console.log('请求参数:', params)
        const res = await this.$http.get('/admin/appointment/list', { params })
        console.log('API返回结果:', res)
        if (res.data.code === 200) {
          // 过滤掉已撤回的预约
          this.tableData = res.data.data.records.filter(item => item.status !== 'withdrawn')
          this.pagination.total = res.data.data.total
          console.log('处理后的数据:', this.tableData)
          console.log('总记录数:', this.pagination.total)
        } else {
          console.error('API返回错误:', res.data.message)
        }
      } catch (e) {
        console.error('加载数据失败:', e)
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = { appointmentNo: '', brokerInfo: '', status: '', date: '', type: '' }
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadData()
    },
    handleView(row, showAudit = false) {
      // 跳转到详情页面
      this.$router.push(`/appointment-audit-detail/${row.id}`)
    },
    isInbound(row) {
      return row && String(row.type || '').toLowerCase() === 'in'
    },
    getStatusType(status) {
      const map = { pending: 'warning', approved: 'success', rejected: 'danger', withdrawn: 'info', cancelled: 'info' }
      return map[status] || 'info'
    },
    getStatusText(status) {
      const map = { pending: '待审核', approved: '已通过', rejected: '已拒绝', withdrawn: '已撤回', cancelled: '已取消' }
      return map[status] || status
    },
    getMaskedPhone(phone) {
      if (!phone) return '-'
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    },
    formatTime(time) {
      if (!time) return '-'
      const date = new Date(time)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    }
  }
}
</script>

<style scoped>
/* 面包屑导航 */
.breadcrumb-container {
  margin: 20px 0;
  font-size: 14px;
}

/* 主卡片 */
.main-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 搜索表单 */
.search-form {
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
  margin-bottom: 20px;
}

.search-form .el-form-item {
  margin-bottom: 0;
  margin-right: 15px;
}

.search-form .el-button {
  border-radius: 4px;
}

.search-form .el-button--primary {
  background-color: #409EFF;
  border-color: #409EFF;
}

/* 表格容器 */
.table-container {
  margin-bottom: 20px;
}

.table-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 15px;
}

/* 预约表格 */
.appointment-table {
  border-radius: 8px;
  overflow: hidden;
  
  .el-table__row:hover {
    background-color: #f5f7fa !important;
  }
  
  .el-table__column--selection {
    width: 55px;
  }
}

/* 预约单号链接 */
.appointment-no-link {
  color: #409EFF;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s;
}

.appointment-no-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}

/* 分页 */
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 审核详情容器 */
.audit-detail-container {
  margin-top: 30px;
  padding: 20px;
  background: #f8fafc;
  border-radius: 8px;
}

.audit-back-link {
  margin-bottom: 20px;
}

.audit-header {
  margin-bottom: 20px;
}

.status-pending {
  color: #E6A23C;
  font-weight: 500;
}

.status-approved {
  color: #67C23A;
  font-weight: 500;
}

.status-rejected {
  color: #F56C6C;
  font-weight: 500;
}

.status-info {
  color: #909399;
  font-weight: 500;
}

/* 审核内容 */
.audit-content {
  display: flex;
  gap: 30px;
}

.left-content {
  flex: 1;
  min-width: 0;
}

.right-content {
  width: 350px;
  flex-shrink: 0;
}

/* 信息卡片 */
.info-card {
  margin-bottom: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.info-card .card-header {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  font-weight: 500;
  color: #303133;
  font-size: 14px;
}

.info-card .card-header i {
  margin-right: 8px;
  color: #409EFF;
  font-size: 16px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .search-form {
    padding: 15px;
  }
  
  .search-form .el-form-item {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  
  .table-container {
    padding: 10px;
  }
  
  .pagination-container {
    padding: 0 10px 10px;
  }
}
</style>
